export default __webpack_public_path__ + "static/media/create.1b65d866.gif";